import { Injectable } from "@angular/core";
import { IExposedUser } from "@shared/interfaces/user.interface";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { SessionService } from "./session.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    private api: ApiService,
    private sessionService: SessionService
  ) {}

  /**
   * Indicates whether authentication is required for API calls
   * @return True if user is logged in, otherwise false
   */
  private get isAuthRequired(): boolean {
    return this.sessionService.isLoggedIn;
  }

  /**
   * Get user infos
   */
  public getUserInfos(): Observable<IExposedUser> {
    return this.api.get("users/info") as Observable<IExposedUser>;
  }

  /**
   * Resend a user the verification email
   * @param email the email of the user
   */
  public resendVerify(email: string): Observable<void> {
    return this.api.post("user/resend-verify", email, undefined, false) as Observable<void>;
  }

  /**
   * Inform the backend that the user has accepted the latest consent form.
   */
  public acceptConsent(): Observable<void> {
    return this.api.post("user/consent", undefined) as Observable<void>;
  }

  /**
   * Change the user's language.
   * @param language new language to use.
   */
  public changeLanguage(language: string): Observable<void> {
    return this.api.patch(this.api.getUpdatedPath("user/change-language"), undefined, this.isAuthRequired, this.api.appendGuestHeader(), {
      code: language,
    }) as Observable<void>;
  }
}
